/** Polling interval (ms) for refreshing the pull-request cockpit view. */
export const PULL_REQUEST_COCKPIT_REFRESH_INTERVAL_MS = 60_000;

/**
 * Floating text/file-selection action toolbar, shared by the message list and
 * the side panel. Intentionally dark in every theme (`bg-desktop-toolbar` +
 * white text/hairlines), so it reads as an overlay above arbitrary content.
 */
export const SELECTION_TOOLBAR_CLASS =
  'fixed z-[110] flex overflow-hidden rounded-xl border border-white/10 bg-desktop-toolbar text-sm text-white shadow-2xl';

/** A selection-toolbar action button (use for the last button in the row). */
export const SELECTION_TOOLBAR_BUTTON_CLASS =
  'px-4 py-2.5 leading-tight hover:bg-white/10 pointer-coarse:min-h-11 max-[479px]:flex-1 max-[479px]:px-2';

/** A selection-toolbar action button with a trailing divider (all but the last). */
export const SELECTION_TOOLBAR_DIVIDER_BUTTON_CLASS = `border-white/10 border-r ${SELECTION_TOOLBAR_BUTTON_CLASS}`;
